keyFieldsFn